import styled from 'styled-components';

export const WrapperContainer = styled.div`
  max-width: 1200px;
  padding: 0 15px;
  margin: 0 auto;
`;
